
function centerComments() {
    $('.reference .carousel_column').css({'position':'absolute', 'top':'50%', 'transform':'translateY(-50%)'});
}

function normalizeSlideHeights() {
    $('.reference .carousel').each(function(){
        var items = $('.carousel-item', this);
        // reset the height
        items.css('min-height', 0);
        // set the height
        var maxHeight = Math.max.apply(null,
            items.map(function(){
                return $(this).outerHeight()}).get() );
        items.css('min-height', maxHeight + 'px');
    });
}

$(window).on(
    'load resize orientationchange',
    normalizeSlideHeights);

$('#myReferences').on('slide.bs.carousel', function () {
    centerComments();
});
